import { IdentityTypeNameDecorator, Expose, BaseIdentity } from '@nts/std';
import { SignTemplateLongOpIdentity } from '../../domain-models/sign-template-long-op.identity';

@IdentityTypeNameDecorator('SignTemplateParamsIdentity')
export class GeneratedSignTemplateParamsIdentity extends SignTemplateLongOpIdentity {
}
